import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import {fetchedTemplates} from './actions';
import {
    setGridFilter,
    unsetGridFilter,
} from '../grid/actions';
import TemplatesGrid from './TemplatesGrid';
import TemplatesFilters from './TemplatesFilters';
import {Heading} from '../../components/heading/heading';
import ScrollToTop from '../../components/scroll-top/ScrollToTop';

class Templates extends Component {

    onFiltersApply() {
        this._child.reload();
    }

    setFilter(filter, value) {
        if (filter && (value === 0 || value === '')) {
            this.props.unsetGridFilter(filter, value, this.props.gridId)
        }

        this.props.setGridFilter(filter, value, this.props.gridId)
    }

    resetGridFilters(filters) {
        filters.map(filter =>
            this.props.unsetGridFilter(filter.id, filter.value, this.props.gridId)
        )
    }

    render() {
        return (
            <div>
                <Heading title={'Templates List'} />
                <TemplatesFilters
                    classes={this.props.classes}
                    filters={this.props.templatesFilters}
                    onFiltersApply={this.onFiltersApply.bind(this)}
                    setFilter={this.setFilter.bind(this)}
                    resetFilters={this.resetGridFilters.bind(this)}
                />
                <TemplatesGrid
                    ref={(child) => {this._child = child; }}
                    pages={this.props.gridTemplates}
                    gridId={this.props.gridId}
                    onFetchedItems={(data, totalPages) => {
                        this.props.fetchedTemplates(data, totalPages);
                    }}
                />
                <ScrollToTop />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    gridTemplates: state.template.all,
    templatesFilters: state.grid.pageTemplatesGrid.filtered,
});

const ConnectedPagesSettings = connect(mapStateToProps, {
    fetchedTemplates,
    setGridFilter,
    unsetGridFilter,
})(withStyles(styles)(Templates));

ConnectedPagesSettings.defaultProps = {gridId: 'pageTemplatesGrid'};

export default ConnectedPagesSettings;


// WEBPACK FOOTER //
// ./src/containers/templates/index.js